var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/navigation-items.j2"] = require( "macros/navigation-items.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/footer/store-locator.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/navigation-items.j2", false, "core/templates/footer/store-locator.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("renderNavItem")) {
var t_4 = t_1.renderNavItem;
} else {
cb(new Error("cannot import 'renderNavItem'")); return;
}
context.setVariable("renderNavItem", t_4);
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footerNavigation")) {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footerNavigation")),"findAStore")) {
var t_5;
t_5 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footerNavigation")),"findAStore");
frame.set("fasNavItem", t_5, true);
if(frame.topLevel) {
context.setVariable("fasNavItem", t_5);
}
if(frame.topLevel) {
context.addExport("fasNavItem", t_5);
}
output += "\n\n            <div class=\"c-quick-links__inner\">\n\n                ";
output += runtime.suppressValue((lineno = 8, colno = 57, runtime.callWrap(t_4, "renderNavItem", context, [runtime.contextOrFrameLookup(context, frame, "fasNavItem"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_6 = runtime.makeMacro(
["navItem", "url", "target"], 
[], 
function (l_navItem, l_url, l_target, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("navItem", l_navItem);
frame.set("url", l_url);
frame.set("target", l_target);
var t_7 = "";t_7 += "\n\n                    <a ";
t_7 += runtime.suppressValue((lineno = 10, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["footer",runtime.memberLookup((l_navItem),"slug")])), env.opts.autoescape);
t_7 += " href=\"";
t_7 += runtime.suppressValue(l_url, env.opts.autoescape);
t_7 += "\" class=\"c-quick-links__a\">\n\n                        <svg class=\"c-quick-links__store-icon\" aria-labelledby=\"a-find-store-title\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 42.3 49.7\" style=\"enable-background:new 0 0 42.3 49.7;\" xml:space=\"preserve\">\n                            <title id=\"a-find-store-title\">";
t_7 += runtime.suppressValue(runtime.memberLookup((l_navItem),"displayName"), env.opts.autoescape);
t_7 += "</title>\n                            <polygon points=\"17.1,21.1 23.8,21.1 20.4,13.4  \"></polygon>\n                            <path d=\"M34.2,30.6H23.5v-1.4h0.3c0.2,0,0.4,0,0.6,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.9-0.1,1.8-0.4,1.8-1.1 c0-0.3-0.1-0.7-0.3-1.2L24.7,23h-8.4l-1.7,3.8c-0.2,0.5-0.3,0.9-0.3,1.2c0,0.6,0.5,0.9,1.6,1.1c0,0,0.1,0,0.1,0 c0.3,0,0.7,0.1,1.2,0.1h0.3v1.4H8.4v-1.4h0.3c0.4,0,0.8,0,1.1-0.1c0.3,0,0.5-0.1,0.8-0.2c0,0,0,0,0.1,0c0.5-0.2,0.9-0.4,1.1-0.7 c0.1-0.2,0.4-0.7,1-2.1l8.1-18.7H21h0.5h0.2l0.1,0.2l8,18.5c0.7,1.7,1.1,2.2,1.4,2.4c0.2,0.2,0.6,0.3,1,0.4c0.1,0,0.1,0,0.2,0 c0.2,0,0.3,0.1,0.5,0.1c0.3,0,0.6,0,0.9,0h0.3V30.6z M21.1,0C9.5,0,0,9.5,0,21.1C0,31,6.8,39.3,15.9,41.6c0.1,0.1,0.2,0.2,0.3,0.3 c2.4,1.1,3.5,5.3,3.8,6.9c0,0.1,0,0.1,0,0.1c0,0.1,0,0.1,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0,0.1,0.1,0.1,0.1 c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0h0c0,0,0.1,0,0.1,0 c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2-0.1c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2 c0-0.1,0-0.1,0.1-0.2c0,0,0-0.1,0-0.1c0.2-1.5,1.4-5.8,3.8-6.9c0.1-0.1,0.2-0.2,0.3-0.3c9.1-2.3,15.9-10.6,15.9-20.5 C42.3,9.5,32.8,0,21.1,0\"></path>\n                        </svg>\n\n                        <div class=\"c-quick-links__title\" data-qa-footer-store-finder>\n                            ";
t_7 += runtime.suppressValue(runtime.memberLookup((l_navItem),"displayName"), env.opts.autoescape);
t_7 += "\n                        </div>\n                    </a>\n\n                ";
;
frame = frame.pop();
return new runtime.SafeString(t_7);
});
return macro_t_6;})()})])), env.opts.autoescape);
output += "\n            </div>";
;
}
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/footer/store-locator.j2"] , dependencies)